import { Injectable } from '@angular/core';
import { pluralize } from '../../utils/string.utils';
import { SelectableJob } from '../select-jobs-grid/select-job.models';

@Injectable({ providedIn: 'root' })
export class SelectJobsSummaryService {
    getJobsToReassign(selectedJobs: SelectableJob[], tenantScheduleId: number): number {
        return selectedJobs?.filter(j => j.tenantScheduleId && j.tenantScheduleId !== tenantScheduleId).length;
    }

    getJobsAlreadyAssigned(selectedJobs: SelectableJob[], tenantScheduleId: number): number {
        return selectedJobs?.filter(j => j.tenantScheduleId && j.tenantScheduleId === tenantScheduleId).length;
    }

    getJobsToAdd(selectedJobs: SelectableJob[]): number {
        return selectedJobs?.filter(j => !j.tenantScheduleId).length;
    }

    getSelectedJobCountStr(
        tenantScheduleId: number,
        jobsToAdd: number,
        jobsToReassign: number,
        jobsAlreadyAssigned: number
    ): string {
        if (!tenantScheduleId) {
            return '';
        }
        const desc = [
            jobsToAdd ? `${jobsToAdd} added` : '',
            jobsToReassign ? `${jobsToReassign} reassigned` : '',
            jobsAlreadyAssigned ? `${jobsAlreadyAssigned} already assigned` : ''
        ]
            .filter(s => s)
            .join(', ');
        return desc ? `(${desc})` : '';
    }

    getSelectedJobCountTooltip(jobsToAdd: number, jobsToReassign: number, jobsAlreadyAssigned: number): string {
        return [
            jobsToAdd
                ? `${jobsToAdd} unscheduled ${pluralize('job is', jobsToAdd, 'jobs are')} being added to this schedule.`
                : '',
            jobsToReassign
                ? `${jobsToReassign} scheduled ${pluralize('job is', jobsToReassign, 'jobs are')} being removed from ${pluralize('its', jobsToReassign, 'their')} current schedule and reassigned to this schedule.`
                : '',
            jobsAlreadyAssigned
                ? `${jobsAlreadyAssigned} ${pluralize('job is', jobsAlreadyAssigned, 'jobs are')} already assigned to this schedule.`
                : ''
        ]
            .filter(s => s)
            .join(' ');
    }
}
